// React
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
// Firebase
import { onAuthStateChanged } from 'firebase/auth';

// Routes
import Control from './pages/Control/Control';
import Home from './pages/Home/Home';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import RequireAdmin from './components/RequireAdmin/RequireAdmin';
import Login from './pages/Login/Login';
import MyProfile from './pages/MyProfile/MyProfile';
import Signup from './pages/Signup/Signup';
import NotFound from './pages/NotFound/NotFound';
import CancelApp from './pages/CancelAppointment/CancelApp';

// Hooks
import { useAuthentication } from './hooks/useAuthentication';

// Context
import { AuthContextProvider } from './context/AuthContext';
import { AdminContextProvider } from './context/AdminContext';
import { ToastProvider, OfflineBanner } from './components/ui';
import { ThemeProvider } from './context/ThemeContext';

// Dev
const UiKit = process.env.NODE_ENV !== 'production'
  ? require('./pages/_dev/UiKit').default
  : null;

function App() {
  const [user, setUser] = useState(undefined);
  const { auth } = useAuthentication();

  const loadingUser = user === undefined;

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });
    return unsubscribe;
  }, [auth]);

  if (loadingUser) {
    return <p className="text-text-primary p-8">Carregando...</p>;
  }

  return (
    <ThemeProvider>
    <AuthContextProvider value={{ user }}>
      <AdminContextProvider>
        <ToastProvider>
          <BrowserRouter>
            <div className="min-h-screen flex flex-col bg-bg">
              <Header />
              <OfflineBanner />
              <main className="flex-1">
                <Routes>
                  <Route path='/' element={<Home />} />
                  <Route path='/controle' element={<RequireAdmin user={user}><Control /></RequireAdmin>} />
                  <Route path='/login' element={!user ? <Login /> : <Navigate to='/profile' />} />
                  <Route path='/profile' element={user ? <MyProfile /> : <Navigate to='/' />} />
                  <Route path='/signup' element={<Signup />} />
                  <Route path='/cancel-appointment/:id' element={<CancelApp />} />
                  {UiKit && <Route path='/uikit' element={<UiKit />} />}
                  <Route path='*' element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </BrowserRouter>
        </ToastProvider>
      </AdminContextProvider>
    </AuthContextProvider>
    </ThemeProvider>
  );
}

export default App;

// New pull request
